import { render, staticRenderFns } from "./myselfSetting.vue?vue&type=template&id=b23622ee&scoped=true"
import script from "./myselfSetting.vue?vue&type=script&lang=js"
export * from "./myselfSetting.vue?vue&type=script&lang=js"
import style0 from "./myselfSetting.vue?vue&type=style&index=0&id=b23622ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23622ee",
  null
  
)

export default component.exports